import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading,
  Substrate,
  WantSeeDemoButton,
} from 'Components/Blocks/_Legacy'
import { Motion, Wrapper } from 'Components/UI'

import { ButtonWrapper, Container, Content } from './styles'

function Inside({ data }) {
  return (
    <Container>
      <Wrapper>
        <Substrate>
          <Content>
            <Motion>
              <Heading
                fontSizes={{ title: [32, 45, 50], sub: [14, 16] }}
                subTitleText={data.subtitleText}
                tagGlyph={null}
                tagText={data.overheadText}
                titleText={{
                  first: {
                    text: data.titleTextFirst,
                    bold: data.firstBold,
                  },
                  second: {
                    text: data.titleTextSecond,
                    bold: data.secondBold,
                  },
                }}
              />
            </Motion>

            <ButtonWrapper>
              <WantSeeDemoButton width="250px" />
            </ButtonWrapper>
          </Content>
        </Substrate>
      </Wrapper>
    </Container>
  )
}

Inside.defaultProps = {
  data: {},
}

Inside.propTypes = {
  data: PropTypes.object,
}

export default Inside
